/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/ZeroData.Props" />
import { IShowPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/ShowPanel.props";

export interface IZeroDataProps extends IShowPanelProps {
    hasWritePermission: boolean;
    onConnectButtonClick?: () => void;
    onOAuthError?: (error: Error) => void;
}
